


export var ON_SEARCH_SELECTED = 'search-selected';